import React, { useRef, useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';

function ModalWrapper(props) {
    const [disableButton, setDisableButton] = useState(props.footerButtonDisabled);
    const modalData = useRef(modalReturnValueInitial);
    useEffect(() => {
        setDisableButton(props.footerButtonDisabled);
        if (props.hasOwnProperty('modalReturnValueInitial')) {
            setmodalData(props.modalReturnValueInitial);
        }
    }, [props]);

    let { modal, toggle, title, submitBtnLabel, size,
        className, modalReturnValueInitial } = props;
    function setmodalData(data) {
        modalData.current = data;
    }
    function submit() {
        if (props.onSubmit) props.onSubmit(modalData.current);
        toggle();
    }

    const childrenWithProps = React.Children.map(props.children, child =>
        React.cloneElement(child, { setModalData: setmodalData, setDisableButton: setDisableButton })
    );

    return (

        <div>
            {/* <Modal isOpen={modal} toggle={toggle} className={className}> */}
            <Modal isOpen={modal} centered toggle={toggle} size={size} className={className} >
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className={props.bodyCustomClass}>
                    {childrenWithProps}
                </ModalBody>
                <ModalFooter>
                    {/* <a disabled={disableButton ? 'disabled' : ''} className="btn btn-primary" color="primary" onClick={submit}>{submitBtnLabel}</a> */}
                    <Button color="primary" onClick={submit} disabled={disableButton}> {submitBtnLabel}</Button>
                    {/* <a className="btn btn-primary" color="secondary" onClick={toggle}>{translate('cancel')}</a> */}
                </ModalFooter>
            </Modal>
        </div>
    )
}
export default ModalWrapper;


ModalWrapper.defaultProps = {
    modal: false,
    toggle: null,
    title: "",
    submitBtnLabel: "",
    size: undefined,
    className: '',
    modalReturnValueInitial: {},
    footerButtonDisabled: false
};
ModalWrapper.propTypes = {
    modal: PropTypes.bool,
    toggle: PropTypes.func,
    title: PropTypes.string,
    className: PropTypes.string,
    submitBtnLabel: PropTypes.string,
    modalReturnValueInitial: PropTypes.any,
    footerButtonDisabled: PropTypes.bool
};